import { i18n } from "i18n/index";
export const TRADING_FEES_CONTENT = [
  {
    col1: i18n.t("Less than 50 million tomans"),
    col2: "۰.33 % ",
    col3: "۰.19 % ",
    col4: i18n.t("Level{{number}}", { number: 1 }),
  },
  {
    col1: i18n.t("Between 50 and 200 million tomans"),
    col2: "۰.25 % ",
    col3: "۰.19 % ",
    col4: i18n.t("Level{{number}}", { number: 2 }),
  },
  {
    col1: i18n.t("Between 200 and 350 million Tomans"),
    col2: "۰.20 % ",
    col3: "۰.15 % ",
    col4: i18n.t("Level{{number}}", { number: 3 }),
  },
  {
    col1: i18n.t("More than 350 million tomans"),
    col2: "۰.18 % ",
    col3: "۰.13 % ",
    col4: i18n.t("Level{{number}}", { number: 4 }),
  },
];
export const RIALS_FEES_CONTENT = [
  {
    col1: i18n.t("Bank accounts other than Future Bank"),
    col2: i18n.t("Between 11pm and 10am"),
    col3: i18n.t("Between 12 and 14 noon"),
  },
  {
    col1: i18n.t("Bank accounts other than Future Bank"),
    col2: i18n.t("Between {{num1}} and {{num2}} o'clock", {
      num1: 13,
      num2: 10,
    }),
    col3: i18n.t("Between {{num1}} and {{num2}} o'clock", {
      num1: 18,
      num2: 16,
    }),
  },
  {
    col1: i18n.t("Bank accounts other than Future Bank"),
    col2: i18n.t("Between {{num1}} and {{num2}} o'clock", {
      num1: 23,
      num2: 13,
    }),
    col3: i18n.t("Between {{num1}} and {{num2}} o'clock", { num1: 6, num2: 4 }),
  },
];
